<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button icon="el-icon-plus" type="primary" @click="handleAdd()">
          新增
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item>
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="请输入姓名/工号/手机号"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table
      v-loading="listLoading"
      :data="list"
      stripe
      @selection-change="setSelectRows"
    >
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="头像"
        prop="basic.avatar"
        width="80px"
      >
        <template #default="{ row }">
          <el-avatar shape="square" :size="40" fit="fill" :src="row.basic.avatar||defaultAvatar"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        v-if="branchs.length > 1"
        align="left"
        label="门店"
        prop="branch.title"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="工号"
        prop="basic.customId"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="姓名"
        prop="basic.name"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="手机号"
        prop="basic.tel"
        show-overflow-tooltip
        width="160px"
      />
      <el-table-column
        align="left"
        label="职务"
        prop="basic.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="部门"
        prop="basic.departmentName"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
        width="160px"
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150"
      >
        <template #default="{ row }">
          <el-button class="mr-10" type="text" @click="handleSetupPermission(row)">
            设置权限
          </el-button>
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              更多
              <i class="el-icon-arrow-down el-icon--right" />
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item :command="{ cmd: 'edit', item: row }">
                  修改
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'resetPwd', item: row }">
                  重置密码
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'delete', item: row }">
                  删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <add ref="add" @fetch-data="fetchData" />
    <edit ref="edit" @fetch-data="fetchData" />
    <setup-permission ref="setupPermission" @fetch-data="fetchData" />
    <share-code ref="shareCode" />
    <reset ref="reset" />
  </div>
</template>

<script>
import moment from 'moment'
import { delStaff, getStaffs, getAllBranchs, createBatch } from '@/api/branch'
import { uploadURL } from '@/config/net.config'
import Add from './add'
import Edit from './edit'
import Reset from './reset.vue'
import ShareCode from './shareCode'
import SetupPermission from './setupPermission'
import defaultAvatar from '@/assets/defaultAvatar.png'
export default {
  name: 'BranchRole',
  components: { Add, Edit, SetupPermission, ShareCode,Reset },
  data() {
    return {
      defaultAvatar,
      moment,
      branchs: [],
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      uploadURL,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
        branchId: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      console.log(to, from)
      if (to.path == '/branch/role') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
    this.getBranchs()
  },
  methods: {
    async getBranchs() {
      this.branchs = await getAllBranchs()
      this.branchs.unshift({
        title: '集团',
        branchId: 'group',
      })
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleCommand(command) {
      if (command.cmd === 'edit') this.handleEdit(command.item)
      else if (command.cmd === 'permission')
        this.handleSetupPermission(command.item)
      else if (command.cmd === 'delete') this.handleDelete(command.item)
      else if(command.cmd==='resetPwd') this.resetPwd(command.item)
    },
    resetPwd(row) {
       this.$refs['reset'].showReset(row)
    },
    handleShareCode(row) {
      this.$refs['shareCode'].showShareCode(row)
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 > 2
      if (isLt2M)
        return this.$message({
          message: '文件大小不能超过2M',
          type: 'warning',
        })
      return true
    },
    async excelSelected(data) {
      if (data.code) {
        this.$message.error({
          message: data.message,
        })
        return
      }
      const res = await createBatch({ file: data.data.url })
      if (!res) return
      if (res && res.length) {
        this.dialogVisible = true
        this.dialogErrors = res
      } else {
        this.$message.success('导入成功')
      }
      this.queryData()
    },
    handleAdd() {
      this.$refs['add'].showAdd()
    },
    handleEdit(row) {
      if (row.peopleId) {
        this.$refs['edit'].showEdit(row)
      } else {
        this.$refs['edit'].showEdit()
      }
    },
    handleSetupPermission(row) {
      if (row.peopleId) {
        this.$refs['setupPermission'].showSetupPermission(row)
      } else {
        this.$refs['setupPermission'].showSetupPermission()
      }
    },
    handleDelete(row) {
      if (row.peopleId) {
        this.$baseConfirm(
          `你确定要删除：${row.basic.name}（${row.basic.customId}）吗`,
          null,
          async () => {
            await delStaff({ peopleId: row.peopleId })
            this.$baseMessage(
              '删除员工成功',
              'success',
              false,
              'vab-hey-message-success'
            )
            await this.fetchData()
          }
        )
      }
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await getStaffs(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .wrap .left-panel {
  align-items: inherit !important;
}
.mr-10 {
  margin-right: 20px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  width: 40px;
  height: 40px;
}
</style>
